import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import ProfileTabs from "../components/profileComponents/ProfileTabs";
import { ListMyOrders } from "../redux/Actions/OrderActions";
import { getUserDetails } from "../redux/Actions/UserActions";
import Orders from "../components/profileComponents/Orders";
import Toast from "../components/LoadingError/Toast";
import { toast } from "react-toastify";
// import Toast from "./../LoadingError/Toast";

const DepositScreen = () => {
  window.scrollTo(0, 0);
  const toastId = React.useRef(null);
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  console.log(userInfo);
  const orderListMy = useSelector((state) => state.orderListMy);
  const { loading, error, orders } = orderListMy;
  const ToastObjects = {
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: false,
    autoClose: 3000,
  };

  useEffect(() => {
    dispatch(ListMyOrders());
    dispatch(getUserDetails("profile"));
  }, [dispatch]);

  const copyTextToClipboard_ = async (ref) => {

    navigator.clipboard.writeText(ref).then(function () {
      // NotificationManager.success("Copying to clipboard was successful!")
      toastId.current = toast.success("Copying to clipboard was successful!", ToastObjects);
    }, function (err) {
      // NotificationManager.warning("Could not copy text")
      toastId.current = toast.warning("Could not copy text", ToastObjects);
    });

  }

  return (
    <>
      <Header />
      <Toast />
      <div className="container mt-lg-5 mt-3">
        <div className="row align-items-start">
          <div className="col-lg-6 p-0 shadow " style={{ margin: 'auto' }}>
            <div style={{ padding: 20 }}>
              <div>Network</div>
              <div>
                <b>BSC</b> BNB Smart Chain (BEP20)
              </div>
              <div style={{ height: 20 }}></div>
              <div>Deposit address</div>
              <div style={{ overflowWrap: 'break-word' }}>
                <b>{userInfo?.address}</b>
                <svg onClick={() => { copyTextToClipboard_(userInfo?.address) }}
                  style={{ marginBottom: 5, marginLeft: 5 }} width="24" height="24" viewBox="0 0 25 25" fill="#310048">
                  <path d="M16.5 13.094v4.2c0 3.5-1.4 4.9-4.9 4.9H7.4c-3.5 0-4.9-1.4-4.9-4.9v-4.2c0-3.5 1.4-4.9 4.9-4.9h4.2c3.5 0 4.9 1.4 4.9 4.9z"></path>
                  <path opacity="0.4" d="M17.6 2.194h-4.2c-3.45 0-4.85 1.37-4.89 4.75h3.09c4.2 0 6.15 1.95 6.15 6.15v3.09c3.38-.04 4.75-1.44 4.75-4.89v-4.2c0-3.5-1.4-4.9-4.9-4.9z"></path>
                </svg>
              </div>
              <div className="img_" style={{ maxWidth: 300, margin: 'auto' }}>
                <img style={{ width: "100%", height: "100%" }} src={`https://quickchart.io/qr?text=${userInfo?.address}&size=360`} alt="" srcset="" />
              </div>
              <div style={{height: 20}}></div>
              <div>
                Note: Please transfer GUSD tokens to the wallet address above!!
              </div>
            </div>
            {/* <div className="author-card pb-0 pb-md-3">
              <div className="author-card-cover"></div>
              <div className="author-card-profile row">
                <div className="author-card-avatar col-md-5">
                  <img src="./images/user.png" alt="userprofileimage" />
                </div>
                <div className="author-card-details col-md-7">
                  <h5 className="author-card-name mb-2">
                    <strong>{userInfo.name}</strong>
                  </h5>
                  <span className="author-card-position">
                    <>Joined {moment(userInfo.createdAt).format("LL")}</>
                  </span>
                </div>
              </div>
            </div>
            <div className="wizard pt-3 ">
              <div className="d-flex align-items-start">
                <div
                  className="nav align-items-start flex-column col-12 nav-pills me-3 "
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <button
                    className="nav-link active"
                    id="v-pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-home"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-home"
                    aria-selected="true"
                  >
                    Profile Settings
                  </button>
                  <button
                    className="nav-link d-flex justify-content-between"
                    id="v-pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-profile"
                    aria-selected="false"
                  >
                    Orders List
                    <span className="badge2">{orders ? orders.length : 0}</span>
                  </button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositScreen;
